import React from "react";
import sharedStyles from "../styles/SharedStyles.module.css";
import deadEnd from "../assets/dead_end.png";

const Room19 = ({ goBack }) => {
  return (
    <div className={sharedStyles.centeredContainer}>
      <h1 className={sharedStyles.pageTitle}>Unnamed Chamber</h1>
      <p className={sharedStyles.pageDescription}>
        The walls here are uneven, carved by time and unseen forces.
      </p>

      <div className={sharedStyles.sceneContainer}>
        {/* Room Image */}
        <img
          src={deadEnd}
          alt="Cave Room"
          className={sharedStyles.sceneImage}
        />
      </div>

      {/* Go Back Button */}
      <button className={sharedStyles.backButton} onClick={goBack}>
        ← Go Back
      </button>
    </div>
  );
};

export default Room19;